<template>
  <div>
    <validation-observer ref="contractValidations">
      <section>
        <b-card>
          <b-row>
            <b-col md="3">
              <b-form-group :label="$t('contract.contract_number')+':'">
                <b-form-input v-model="contract.contract_number" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('contract.contract_date')+':'">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('contract.contract_date')"
                  rules="required"
                >
                  <flat-pickr
                    v-model="contract.date"
                    class="form-control bg-white"
                    style="max-width: 250px;"
                    :config="configdateTimePicker"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('contract.brand')+':'">
                <b-form-input
                  v-model="GET_ONE_CONSTRUCTOR.title"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('generals.file')+':'">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('generals.file')"
                  rules="required"
                >
                  <b-form-file
                    v-model="contract.files"
                    accept=".pdf"
                    :browse-text="$t('generals.select')"
                    :placeholder="$t('generals.no_file_chosen')"
                    multiple
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card :title="$t('contract.contract_base')+':'">
          <b-row>
            <b-col md="3">
              <b-form-group :label="$t('contract.residence')+':'">
                <v-select
                  v-model="rc_object"
                  :options="GET_OBJECTS"
                  :reduce="object => object.id"
                  label="title"
                  @input="object_id => {
                    objectChange()
                    objectSelect(object_id)
                  }"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('objects.apartment_block')+':'">
                <v-select
                  v-model="apartment"
                  :options="GET_APARTMENTS"
                  :reduce="apartment => apartment.id"
                  label="title"
                  :disabled="!rc_object"
                  @input="apt_id => {
                    apartmentChange()
                    apartmentSelect(apt_id)
                  }"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('objects.section')+':'">
                <v-select
                  v-model="section"
                  :options="GET_SECTIONS"
                  :reduce="section => section.id"
                  label="title"
                  :disabled="!apartment"
                  @input="() => {
                    sectionSelect()
                    sectionChange()
                  }"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('objects.floor')+':'">
                <v-select
                  v-model="stage"
                  :options="GET_STAGES"
                  label="title"
                  :disabled="!section"
                  :reduce="stage => stage.id"
                  @input="stagaChange"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('contract.flat_number')+':'">
                <validation-provider
                  #default="{ errors }"
                  name="№ квартиры"
                  rules="required"
                >
                  <v-select
                    v-model="contract.flat"
                    :options="getFlats"
                    label="flat_number"
                    :disabled="!stage"
                    :reduce="flat => flat.id"
                    @input="flat_id => {
                      flatChange();
                      flatChosen(flat_id)
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('contract.rooms_count')+':'">
                <b-form-input
                  v-model="GET_ONE_FLAT.rooms_count"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('contract.flat_area')+'(м²):'">
                <b-form-input
                  v-model="contract.old.total_area"
                  type="number"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('objects.price')+' м²:'">
                <cleave
                  id="pricePerKv"
                  v-model="contract.old.price_per_kv"
                  class="form-control"
                  :raw="true"
                  :options="price_options"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('objects.total_cost_of_the_apartment')+':'">
                <cleave
                  id="totalPrice"
                  v-model="contract.old.total_price"
                  class="form-control"
                  :raw="true"
                  :options="price_options"
                />
              </b-form-group>
            </b-col>
            <b-col class="d-flex align-items-center">
              <b-button
                class="mt-1 ml-auto"
                variant="primary"
                @click="openGridSidebar"
              >
                <feather-icon icon="GridIcon" />
                {{ $t('contract.choose_from_grid') }}
              </b-button>
            </b-col>
          </b-row>
        </b-card>
        <b-card :title="$t('objects.payment')">
          <b-row>
            <!-- <b-col md="3">
              <b-form-group label="Тип оплаты:">
                <validation-provider
                  #default="{ errors }"
                  name="Тип оплаты"
                  rules="required"
                >
                  <v-select
                    v-model="selected_payment_type"
                    :options="payment_type_options"
                    :disabled="!rc_object"
                    :get-option-label="type => type.title[$i18n.locale]"
                    @input="paymentTypeSelect"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <b-col md="3">
              <b-form-group :label="$t('contract.payment_method')+':'">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('contract.payment_method')"
                  rules="required"
                >
                  <v-select
                    v-model="contract.payment_method"
                    :options="GET_PAYMENT_METHODS"
                    multiple
                    :placeholder="$t('contract.payment_method')"
                    :reduce="payment_method => payment_method.id"
                    :get-option-label="method => method.title[$i18n.locale]"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('contract.payment_interest_installment')+'(%):'">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('contract.payment_interest_installment')"
                  rules="required|between:0,100"
                >
                  <b-form-input
                    v-model="contract.old.calculation"
                    type="number"
                    placeholder="0"
                    :max="100"
                    :min="0"
                  />
                  <!-- :get-option-label="option => option.payment_in_percent.value" -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('contract.discount_received')+'(%):'">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('contract.discount_received')"
                  rules="required|between:0,100"
                >
                  <b-form-input
                    v-model="contract.old.discount_in_percent"
                    placeholder="0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('contract.count_of_installments')+':'">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('contract.count_of_installments')"
                  rules="required"
                >
                  <b-form-input
                    v-model="contract.old.installment"
                    placeholder="0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('contract.monthly_payment')+':'">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('contract.monthly_payment')"
                  rules="required"
                >
                  <cleave
                    v-model="contract.old.monthly_payment"
                    placeholder="0"
                    class="form-control"
                    :raw="true"
                    :options="price_options"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card :title="$t('contract.contact_data')+':'">
          <b-row>
            <b-col md="4">
              <b-form-group :label="$t('clients.client')+':'">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('clients.client')"
                  rules="required"
                >
                  <v-select
                    v-model="selected_client"
                    class="clients-select-contracts"
                    :options="client_options"
                    label="title"
                    @input="selectClient"
                    @open="onOpen"
                    @close="onClose"
                    @search="searchClients"
                  >
                    <template #list-footer>
                      <li
                        v-show="hasNextPage"
                        ref="clientsLoad"
                        class="clients-select-contracts-loader"
                      >
                        Loading more options...
                      </li>
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="8">
              <validation-provider
                #default="{ errors }"
                :name="$t('contract.customer_name')"
                rules="required"
              >
                <b-form-group :label="$t('contract.customer_name')+':'">
                  <v-select
                    v-model="contract.customer"
                    :options="getOneClient.employee"
                    :reduce="customer => customer.id"
                    :disabled="!selected_client"
                    label="name"
                  />
                </b-form-group>
                <b-button
                  v-b-modal.employee-modal
                  variant="primary"
                  class="mb-1"
                  :disabled="!selected_client"
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <b-row>
            <b-col md="4">
              <b-form-group :label="$t('clients.manager')">
                <v-select
                  v-model="contract.author"
                  :options="GET_USERS.results"
                  :get-option-label="opt => opt.username"
                  :reduce="opt => opt.id"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </section>
      <section class="d-flex">
        <b-button
          class="mr-1"
          @click="$router.push({ name: 'unsigned-contracts' })"
        >
          {{ $t('generals.back') }}
        </b-button>
        <b-button
          variant="primary"
          @click="saveClick"
        >
          {{ $t('generals.save') }}
        </b-button>
        <div
          v-if="isEdit"
          class="ml-auto"
        >
          <b-button
            variant="warning"
            class="ml-auto"
            @click="downloadPdf"
          >
            <feather-icon icon="DownloadIcon" />
            Скачать в PDF
          </b-button>
        </div>
      </section>
      <b-sidebar
        v-model="grid_sidebar"
        width="100vw"
      >
        <filter-for-grid
          :views-dropdown="false"
          :filters="[]"
          :query-params.sync="query_params"
          :def_object="rc_object"
          :def_apartment="apartment"
          @apartmentChanged="apartmentSelect"
          @objectChanged="objectSelect"
        />
        <b-card>
          <b-overlay
            :show="overlay"
            rounded="lg"
            opacity="0.6"
          >
            <vue-selecto
              :data="GET_CHECKERBOARD_LAYOUT"
              :sidebar="true"
              :filter="query_params"
              @flatSelected="openRightSidebar"
            />
          </b-overlay>
        </b-card>
        <right-sidebar
          v-model="right_sidebar"
          :item="selected_flat"
          :flat-choosing="true"
          @photoClicked="showInLargeSize"
          @flatChoose="flat_id => {
            flatChange()
            flatChosen(flat_id)
          }"
        />
        <left-sidebar
          v-model="left_sidebar"
          :image="selected_image"
        />
      </b-sidebar>

      <!-- <b-sidebar
        v-model="grid_sidebar"
        width="100vw"
      >
        <block-view
          :id="apartment"
          :filters="[]"
          :views-dropdown="false"
          :flat-choosing-btn="true"
          @objectChanged="objectSelect"
          @apartmentChanged="apartmentSelect"
          @flatChoose="flatChosen"
        />
      </b-sidebar> -->

      <customer-modal
        :parent_id="getOneClient.id"
        @refresh="selectClient"
        @success="customerSaved"
      />
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BFormInput,
  BFormGroup,
  BCard,
  BSidebar,
  BFormFile,
  BOverlay,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from 'flatpickr/dist/l10n/ru'
import VSelect from 'vue-select'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Cleave from 'vue-cleave-component'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required, between } from '@validations'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
// import blockView from '../MyObjects/Apartments/blockView.vue'
// import lazyLoadingSelect from '@/components/lazyLoadingVSelect.vue'
import customerModal from '../Clients/components/EmployeeModal.vue'
import filterForGrid from '../MyObjects/Apartments/components/filterForGrid.vue'
import vueSelecto from '@/components/vueSelecto.vue'
import rightSidebar from '../MyObjects/Apartments/components/flatSidebar.vue'
import leftSidebar from '../MyObjects/Apartments/components/leftImageSidebar.vue'
import formatters from '@/mixins/extra'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    FeatherIcon,
    flatPickr,
    VSelect,
    BCard,
    BSidebar,
    ValidationObserver,
    ValidationProvider,
    Cleave,
    filterForGrid,
    // blockView,
    customerModal,
    // lazyLoadingSelect,
    vueSelecto,
    leftSidebar,
    rightSidebar,
    BFormFile,
    BOverlay,
  },
  mixins: [formatters],
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    client: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    contractSubject: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      contract: {
        date: '',
        old: {
          monthly_payment: null,
          installment: null,
        },
      },
      query_params: {
        rooms_count_list: [],
        total_area_start: '',
        total_area_end: '',
        total_price_end: '',
        total_price_start: '',
        current_status: [],
      },
      selected_image: '',
      payment_type_options: [],
      selected_payment_type: null,
      selected_calculation: {},
      right_sidebar: false,
      left_sidebar: false,
      selected_client: null,
      rc_object: null,
      apartment: null,
      section: null,
      stage: null,
      grid_sidebar: false,
      selected_flat: {
        current_status: {
          title: {},
        },
      },
      configdateTimePicker: {
        altInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'Y-m-d',
        locale: Russian,
      },
      customer_info: {},
      client_options: [],
      client_query: {
        page: 1,
        page_size: 10,
        search: '',
        partial: true,
      },
      observer: null,
      required,
      between,
      overlay: false,
      price_options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
      },
      percent_options: {
        blocks: [3],
        uppercase: true,
      },
    }
  },
  computed: {
    ...mapGetters('objects', [
      'GET_OBJECTS',
      'GET_ONE_OBJECT',
      'GET_ONE_PAYMENT_TYPE',
    ]),
    ...mapGetters('apartments', ['GET_APARTMENTS', 'GET_CHECKERBOARD_LAYOUT']),
    ...mapGetters('sections', ['GET_SECTIONS']),
    ...mapGetters('stages', ['GET_STAGES']),
    ...mapGetters('clients', [
      'getClientsList',
      'getOneClient',
      'GET_ONE_EMPLOYEE',
    ]),
    ...mapGetters('flats', ['GET_ONE_FLAT']),
    ...mapGetters('knowledgeBase', [
      'GET_PAYMENT_METHODS',
      'GET_ONE_CONSTRUCTOR',
    ]),
    ...mapGetters('contracts', ['GET_ONE_CONTRACT']),
    ...mapGetters('users', ['GET_USERS']),
    getFlats() {
      if (this.stage && this.GET_STAGES.length) {
        const { flats } = this.GET_STAGES.find(el => el.id === this.stage)
        return flats
        // return this.stage.flats
      }
      return []
    },
    hasNextPage() {
      return this.client_options.length < this.getClientsList.count
    },
    getCalculationsOptions() {
      if (this.selected_payment_type) {
        if (this.selected_payment_type.is_full) {
          return this.GET_ONE_FLAT.calculations.filter(
            el => el.monthly_payment === null,
          )
        }
        if (!this.selected_payment_type.is_full) {
          return this.GET_ONE_FLAT.calculations.filter(
            el => el.monthly_payment !== null,
          )
        }
      }
      return []
    },
  },
  mounted() {
    this.FETCH_OBJECTS({ partial: true })
    this.SET_APARTMENT_CHECKERBOARD_LAYOUT([])
    this.FETCH_USERS({ page_size: 1000 })
    if (this.isEdit) {
      this.FETCH_ONE_CONTRACT(this.$route.params.id).then(() => {
        this.contract = this.GET_ONE_CONTRACT
        this.objectSelect(this.GET_ONE_CONTRACT.rc_object)
        this.apartmentSelect(this.GET_ONE_CONTRACT.apartment)
        // this.section = this.GET_ONE_CONTRACT.section
        // this.sectionSelect()
        // this.stage = this.GET_ONE_CONTRACT.stage
        // this.FETCH_ONE_FLAT(this.GET_ONE_CONTRACT.flat)
        this.FETCH_ONE_EMPLOYEE(this.contract.customer).then(customer_res => {
          this.FETCH_ONE_CLIENT(customer_res.company).then(() => {
            this.selected_client = this.getOneClient
          })
        })
        this.FETCH_ONE_PAYMENT_TYPE(this.GET_ONE_CONTRACT.payment_type).then(
          () => {
            this.selected_payment_type = this.GET_ONE_PAYMENT_TYPE
            this.flatChosen(this.GET_ONE_CONTRACT.flat)
            // this.calculationSelect(this.GET_ONE_CONTRACT.calculation)
          },
        )
      })
    } else if (this.contractSubject.flat) {
      this.objectSelect(this.contractSubject.rc_object)
      this.apartmentSelect(this.contractSubject.apartment)
      this.flatChosen(this.contractSubject.flat)
      this.selected_client = JSON.parse(
        sessionStorage.getItem('selected_client'),
      )
      this.selectClient()
    }
    this.FETCH_CLIENTS_LIST(this.client_query).then(() => {
      this.client_options = this.getClientsList.results
    })
    this.FETCH_PAYMENT_METHODS()
    this.observer = new IntersectionObserver(this.infiniteScroll)
    this.contract.date = new Date()
  },
  methods: {
    ...mapActions('objects', [
      'FETCH_OBJECTS',
      'FETCH_ONE_OBJECT',
      'FETCH_ONE_PAYMENT_TYPE',
    ]),
    ...mapActions('apartments', [
      'FETCH_APARTMENTS_BY_OBJECT',
      'FETCH_APARTMENT_CHECKERBOARD_LAYOUT',
    ]),
    ...mapActions('sections', ['FETCH_APARTMENT_SECTIONS']),
    ...mapActions('stages', ['FETCH_STAGES_BY_SECTION']),
    ...mapActions('clients', [
      'FETCH_CLIENTS_LIST',
      'FETCH_ONE_CLIENT',
      'FETCH_ONE_EMPLOYEE',
    ]),
    ...mapActions('flats', ['FETCH_ONE_FLAT']),
    ...mapActions('knowledgeBase', [
      'FETCH_PAYMENT_METHODS',
      'FETCH_ONE_CONSTRUCTOR',
    ]),
    ...mapActions('contracts', [
      'ADD_CONTRACT',
      'EDIT_CONTRACT',
      'FETCH_ONE_CONTRACT',
      'DOWNLOAD_CONTRACT_PDF',
    ]),
    ...mapMutations('flats', ['SET_ONE_FLAT']),
    ...mapMutations('apartments', ['SET_APARTMENT_CHECKERBOARD_LAYOUT']),
    ...mapMutations('knowledgeBase', ['SET_ONE_CONSTRUCTOR']),
    ...mapActions('users', ['FETCH_USERS']),
    saveClick() {
      console.log(this.contract)
      this.$refs.contractValidations.validate().then(success => {
        if (success) {
          if (this.isEdit) {
            const {
              id,
              flat,
              customer,
              payment_method,
              payment_type,
              calculation,
              date,
            } = this.contract
            const reqObj = {
              id,
              flat,
              customer,
              payment_method,
              payment_type,
              calculation,
              date,
            }
            this.EDIT_CONTRACT(reqObj)
              .then(() => {
                this.$_successToast(this.$t('generals.updated'))
                this.$router.push({ name: 'unsigned-contracts' })
              })
              .catch(() => {
                this.$_errorToast(this.$t('generals.error'))
              })
          } else {
            this.contract.sign_in = true
            const { old, author, ...rest } = this.contract
            const reqObj = {
              old: JSON.stringify(old),
              author: author || useJwt.getUserData().id,
              is_active: true,
              ...rest,
            }
            const fd = this.$_objectToFormData(reqObj)
            // Object.keys(this.contract).forEach(el => {
            //   if (el === 'payment_method') {
            //     this.contract.payment_method.forEach(k => {
            //       fd.append('payment_method', k)
            //     })
            //   } else if (el === 'old') {
            //     console.log('old')
            //   } else {
            //     fd.append(el, this.contract[el])
            //   }
            // })
            // alert(fd)
            this.ADD_CONTRACT(fd)
              .then(() => {
                this.$_successToast(this.$t('generals.added'))
                this.$router.push({ name: 'unsigned-contracts' })
              })
              .catch(err => {
                if (err.response.status === 406) {
                  this.$_showCustomModal(
                    this.$t('generals.please_confirm'),
                    this.$t('contract.contract_exists'),
                  ).then(res => {
                    if (res) {
                      const promises = []
                      err.response.data.forEach(el => {
                        promises.push(
                          this.EDIT_CONTRACT({ id: el, is_active: false }),
                        )
                      })
                      Promise.all(promises).then(() => {
                        this.saveClick(this.contract)
                      })
                    }
                  })
                }
                this.$_errorToast(this.$t('generals.error'))
              })
          }
        }
      })
    },
    openGridSidebar() {
      this.grid_sidebar = true
    },
    signUpContract() {
      console.log('nin')
    },
    objectSelect(object_id) {
      if (object_id) {
        this.rc_object = object_id
        this.FETCH_APARTMENTS_BY_OBJECT({ id: this.rc_object })
        this.FETCH_ONE_OBJECT(object_id).then(res => {
          this.payment_type_options = res.payment_type
          this.FETCH_ONE_CONSTRUCTOR(res.brand)
        })
      }
    },
    objectChange() {
      this.selected_payment_type = null
      this.apartment = null
      this.apartmentChange()
    },
    apartmentSelect(apartment_id) {
      this.apartment = apartment_id
      if (apartment_id) {
        this.FETCH_APARTMENT_SECTIONS(apartment_id)
        this.overlay = true
        this.FETCH_APARTMENT_CHECKERBOARD_LAYOUT(apartment_id).then(() => {
          this.overlay = false
        })
      }
    },
    apartmentChange() {
      this.section = null
      this.sectionChange()
    },
    sectionSelect() {
      this.FETCH_STAGES_BY_SECTION({ id: this.section, partial: true })
    },
    sectionChange() {
      this.stage = null
      this.stagaChange()
    },
    stagaChange() {
      this.contract.flat = null
      this.flatChange()
      this.SET_ONE_FLAT({})
    },
    flatChosen(data) {
      if (data) {
        this.contract.flat = data
        this.grid_sidebar = false
        this.FETCH_ONE_FLAT(data).then(() => {
          this.section = this.GET_ONE_FLAT.section
          this.sectionSelect()
          this.stage = this.GET_ONE_FLAT.stage
          if (this.isEdit) {
            this.calculationSelect(this.GET_ONE_CONTRACT.calculation)
          }
        })
      } else {
        this.SET_ONE_FLAT({ calculations: [] })
      }
    },
    flatChange() {
      this.contract.calculation = null
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.clientsLoad)
      }
    },
    onClose() {
      this.observer.disconnect()
    },
    infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const { scrollTop } = target.offsetParent
        console.log(scrollTop)
        this.client_query.page += 1
        this.FETCH_CLIENTS_LIST(this.client_query).then(() => {
          this.client_options.push(...this.getClientsList.results)
          this.$nextTick(() => {
            ul.scrollTop = scrollTop
          })
        })
      }
    },
    searchClients(search) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.client_query.page = 1
        this.FETCH_CLIENTS_LIST({ search, partial: true }).then(() => {
          this.client_options = this.getClientsList.results
        })
      }, 600)
    },
    selectClient() {
      this.FETCH_ONE_CLIENT(this.selected_client.id)
    },
    customerSelected() {},
    showInLargeSize(url) {
      this.selected_image = url
      this.left_sidebar = true
    },
    openRightSidebar(flat) {
      this.selected_flat = flat
      this.FETCH_ONE_FLAT(flat.id).then(() => {
        this.selected_flat = this.GET_ONE_FLAT
      })
      this.right_sidebar = true
    },
    paymentTypeSelect(type) {
      this.contract.payment_type = type.id
      if (type.is_full) {
        this.contract.calculation = this.getCalculationsOptions[0].id
        this.calculationSelect(this.contract.calculation)
      } else {
        this.contract.calculation = null
      }
    },
    calculationSelect(calc_id) {
      this.selected_calculation = this.getCalculationsOptions.find(
        el => el.id === calc_id,
      )
    },
    customOption(e) {
      if (typeof e === 'object') return e.payment_in_percent.value
      return ''
    },
    calcTotalPrice() {
      this.contract.old.total_price = Number(
        this.contract.old.total_area * this.contract.old.price_per_kv,
      )
    },
    downloadPdf() {
      this.DOWNLOAD_CONTRACT_PDF(this.$route.params.id).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.contract.contract_number}.docx`)
        document.body.appendChild(link)
        link.click()
      })
    },
    customerSaved() {
      this.selectClient()
    },
  },
  destroyed() {
    this.SET_ONE_FLAT({ calculations: [] })
    this.SET_ONE_CONSTRUCTOR({})
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.clients-select-contracts-loader {
  text-align: center;
  color: #bbbbbb;
}
.clients-select-contracts ul {
  max-height: 200px;
}
</style>
